
























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';
import UpdateOrganisationRequest from '@/models/Customers/Organisations/UpdateOrganisationRequest';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';

@Component({ name: 'OrganisationEdit' })
export default class extends SaascadaVueDialog {

    request: UpdateOrganisationRequest = new UpdateOrganisationRequest();

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateOrganisationRequest();
            this.request.name = OrganisationModule.organisation.name;
            this.request.registrationNumber = OrganisationModule.organisation.registrationNumber;
            this.request.registrationCountry = OrganisationModule.organisation.registrationCountry;
        }
    }

    get countryOptions() {
        return ListUtils.countryOptions()
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await OrganisationModule.editOrganisation(this.request)
        }
    }

}
